import { apiRequest } from '../utils/api';

export const getDashboardOverview = ({ outletId = '', month, year } = {}, navigate) => {
  const params = new URLSearchParams();
  if (outletId) params.set('outletId', outletId);
  if (month) params.set('month', month);
  if (year) params.set('year', year);
  const query = params.toString();
  return apiRequest(`/api/admin/dashboard/overview${query ? `?${query}` : ''}`, {}, navigate);
};
